jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });
  
});
  // Função para mostrar a div ao clicar em "Personalizar"
  document.querySelector('[data-value="Sim"]').addEventListener('click', function() {
    document.getElementById('aparecer').style.display = 'block';
  });

  // Função para ocultar a div ao clicar em "Não Personalizar"
  document.querySelector('[data-value="Não"]').addEventListener('click', function() {
    document.getElementById('aparecer').style.display = 'none';
  });